import { FC } from "react";

interface PhoneIconSVGProps {
    className?: string;
}

const PhoneIconSVG: FC<PhoneIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M29.33 22.5614V26.5614C29.3315 26.9328 29.2554 27.3003 29.1067 27.6406C28.9579 27.9808 28.7397 28.2862 28.4661 28.5373C28.1925 28.7883 27.8694 28.9794 27.5177 29.0984C27.1659 29.2173 26.7932 29.2615 26.4233 29.2281C22.3204 28.7823 18.3793 27.3803 14.9167 25.1348C11.6951 23.0877 8.96377 20.3563 6.91666 17.1348C4.66329 13.6564 3.26098 9.69609 2.82332 5.57476C2.79 5.20605 2.83382 4.83445 2.95199 4.4836C3.07016 4.13275 3.26008 3.81035 3.50968 3.53693C3.75927 3.2635 4.06306 3.04504 4.40171 2.89546C4.74036 2.74588 5.10644 2.66845 5.47666 2.6681H9.47666C10.1237 2.66173 10.751 2.89087 11.2417 3.31281C11.7323 3.73475 12.0528 4.32069 12.1433 4.96143C12.3122 6.24152 12.6253 7.4984 13.0767 8.7081C13.256 9.18533 13.2949 9.70398 13.1885 10.2026C13.0822 10.7012 12.8351 11.1589 12.4767 11.5214L10.7833 13.2148C12.6814 16.5528 15.4453 19.3167 18.7833 21.2148L20.4767 19.5214C20.8392 19.1629 21.2969 18.9159 21.7955 18.8096C22.2941 18.7032 22.8128 18.742 23.29 18.9214C24.4997 19.3728 25.7566 19.6859 27.0367 19.8548C27.6843 19.9461 28.2759 20.2724 28.6987 20.7714C29.1215 21.2705 29.3462 21.9075 29.33 22.5614Z"
                stroke="currentColor"
                strokeWidth="2.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PhoneIconSVG;
